import { Site } from "../../shared/models/site.model";
import { getErrorPagePath, getFirstAvailablePagePath } from "../../shared/path-resolve.utils";

/**
 * Maps the browser location to the SPA file path stored in {@link FileState.path}.
 * Must stay aligned with SSR path resolution (layout segment, site prefix).
 */
export function deriveFilePathFromSiteLocation(input: {
    pathname: string;
    sitePath: string | null | undefined;
    site: Site | null | undefined;
    currentFilePath: string | undefined;
}): string {
    const { pathname, sitePath, site, currentFilePath } = input;
    const files = site?.files;

    let path: string = pathname;
    if (sitePath) {
        path = path.replace(sitePath, "");
    }
    const segments = path.split("/").filter(Boolean);
    if (segments.length > 0 && segments[0].startsWith("~")) {
        path = "/" + segments.slice(1).join("/");
    }
    if (!path || path === "/") {
        if (currentFilePath === getErrorPagePath(files, "guestNotAllowedPage")) {
            return getFirstAvailablePagePath(site?.files, ["guestNotAllowedPage", "defaultFile", "onlineStartPage"]) || "/home.html";
        }
        return getFirstAvailablePagePath(site?.files, ["defaultFile", "onlineStartPage"]) || "/home.html";
    }
    return path;
}
